var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('HeaderForm',{staticClass:"title-form-pengiriman",attrs:{"title":'Tambah Perjalanan ' + _vm.type,"note":"perjalanan"}}),_c('Form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }